export default `
el Abadejo
el Abalone
el Abejarón
el Abejaruco
la Abeja
el Abejorro
el Ácaro
la Acedía
el Acentor
el Agamido
el Águila
el Alacrán
el Albatros
el Alce
la Almeja
la Alondra
el Ánade Real
la Anchoa
la Anémona de mar
el Anfioxo
el Angelote
la Anguila
el Antílope
la Araña
el Arenque
el Armadillo
el Armiño
el Asno
el Atún
la Avefría
el Avestruz
el Avetoro
la Avispa
la Babirusa
la Babosa
el Babuino
el Bacalao
la Ballena
el Banteng
el Barasinga
la Barracuda
la Becada
la Beira
la Beluga
el Bengalí
la Bermejuela
el Berrendo
el Besugo
la Bisbita
el Bisonte
el Blanquillo
la Boa
el Bogavante
el Bongo
el Bonito
el Bonobo
el Boto
el Buey
el Búfalo
el Búho
el Buitre
el Burro
el Caballo
el Caballito de mar
la Cacatúa
el Cachalote
el Calamón
el Camaleón
el Camello
el Canguro
el Canario
el Cangrejo
el Caracol
el Castor
la Cebra
el Centollo
el Cerdo
el Chacal
el Chimpancé
la Chinchilla
el Ciempiés
el Ciervo
la Cigala
el Cisne
la Cobaya
la Cochinilla
el Cocodrilo
el Coendú
el Coipú
el Colibrí
la Comadreja
el Conejo
el Coral
la Coridora
el Cormorán
el Cóndor
la Cotorra
el Coyote
el Damán
el Delfín
el Diablo de Tasmania
el Dik-dik
el Dingo
el Dragón de Komodo
el Dromedario
el Elefante
el Emú
la Equidna
el Erizo
el Escarabajo
el Escorpión
el Escuerzo
la Espátula
la Estrella de mar
la Farra
el Faisán
el Flamingo
el Flamenco
la Foca
la Gacela
el Galápago
la Gallina
el Gallipato
el Gallo
la Gamba
el Ganso
la Garcilla
la Garrapata
la Garza
el Gato
el Gavilán
el Glotón
la Golondrina
el Gorila
el Gorgojo
el Gorrión
el Grillo
la Grulla
el Guepardo
el Halcón
el Hamster
la Hiena
el Hipocampo
el Hipopótamo
la Holoturia
la Hormiga
el Hurón
el Hupón
el Ibice
la Icotea
la Iguana
el Insecto palo
el Intendio
la Impala
el Jabalí
el Jabirú
el Jerbo
la Jirafa
el Jaguar
el Kaguang
el Kiwi
el Krill
el Koala
el Labro
el Lagarto
la Langosta
el Langostino
la Lechuza
el Lémur
el León
el León marino
el Leopardo
la Libélula
la Liebre
el Lince
la Llama
el Lobo
el Lobo marino
la Lombriz
el Loro
la Luciérnaga
el Mamut
el Mandril
la Mantis religiosa
el Mapache
el Marabú
el Marabunta
la Mariposa
la Marmota
la Medusa
el Mejillón
el Milpiés
la Mofeta
el Mono
la Mosca
el Mosquito
la Morsa
el Murciélago
el Narval
la Navaja
la Nécora
la Nutria
el Ñandú
el Ñu
el Ocelote
el Okapi
el Oso
el Oso de agua
el Oso hormiguero
el Oso panda
el Oso pardo
el Ornitorrinco
la Oveja
el Pájaro
la Paloma
la Pantera
el Papagayo
el Pelicano
la Perca
la Perdiz
el Perezoso
el Perico
el Peripato
el Periquito
el Perro
el Petirrojo
el Pez
el Pingüino
el Pinzón
el Piojo
el Piquituerto
la Polilla
el Puercoespín
la Pulga
el Pulpo
el Puma
el Quebrantahuesos
el Quetzal
el Quitón
la Rana
la Rata
el Ratón
la Raya
el Rebeco
la Rémora
el Reno
el Rinoceronte
el Rubia Gallega
el Ruiseñor
la Salamandra
el Salmón
el Saltamontes
la Sanguijuela
el Sapo
la Sepia
la Serpiente
el Tábano
el Tejón
la Tenia
la Termita
el Tiburón
el Tigre
la Tijereta
el Topo
el Toro
la Tortuga
el Tritón
la Trucha
el Tucán
el Urogallo
la Urraca
la Vaca
el Varano
el Venado
la Vicuña
el Wapití
el Walabi
el Walaró
la Weta
el Wombat
el Xenopus
el Xenopus laevis
el Xoloescuintle
el Yak
el Yacare
la Yegua
la Zarigüeya
el Zorro
la Zebra
`
.trim().split('\n')
